export default __webpack_public_path__ + "static/media/pin-green-hub.55c75835.png";